import * as api from "@/api/welders";
import { useQuery } from "react-query";

export function useQualifierWelderProfiles() {
  return useQuery(["welders", "qualifier"], api.getQualifierWelderProfiles);
}

export function useCoordinatorWelderProfiles() {
  return useQuery(["welders", "coordinator"], api.getCoordinatorWelderProfiles);
}
